import Modal from "@mui/material/Modal";
import { ReactNode } from "react";

type ModalProps = {
  open: boolean;
  handleClose?: () => void;
  children: ReactNode;
  blurBackdrop?: boolean;
  wrapperClassName?: string; // for layout styling (width, position)
  className?: string; // for content styling (bgColor)
};
const ModalWrapper = ({ open, handleClose, children, blurBackdrop = false, wrapperClassName = "", className = "" }: ModalProps) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      slotProps={{
        ...(blurBackdrop && {
          backdrop: {
            sx: {
              backdropFilter: "blur(8px)",
            },
          },
        }),
      }}
    >
      <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow rounded-lg text-mui-black-87 dark:text-white w-modal-mobile sm:w-modal-md ${wrapperClassName} ${className}`}>
        {children}
      </div>
    </Modal>
  );
};

export default ModalWrapper;
